import _ from "lodash";
import { useEffect, useState } from "react";
import { Button, Col, Form, Row, Table } from "react-bootstrap";
import { Files, PlusSquareFill, TrashFill } from "react-bootstrap-icons";
import { NumericFormat } from "react-number-format";
import { useLocation, useSessionStorage } from "react-use";
import Swal from "sweetalert2";
import ChooseBankAccountForOrder from "../../../../../components/Shipment/CODRequest/ChooseBankAccountForOrder";
import PackageSelect from "../../../../../components/Shipment/register/PackageSelect";
import { getMethod } from "../../../../../function/helper";
import swalFormErrorMessage from "../../functions/swalFormErrorMessage";
import weightValidation from "../../functions/weight/weightValidation";
import getAddressOrderShipement from "../../hooks/address/getAddressOrderShipement";
import style from "./FormShipment.module.css";
import FormShipmentInfo from "./FormShipmentInfo";
import ModalRules from "./ModalRules";
import PostServiceList from "./PostServiceList";

function FormShipment() {
  const { pathname } = useLocation();
  const isCod = pathname.includes("/new/cod") ? true : false;

  const { sender: SAddress, getter: RAddress } = getAddressOrderShipement();

  const shipmentTemplate = {
    partNumber: 101,
    weight: "",
    length: "",
    width: "",
    height: "",
    mass: "",
    massUnround: "",
    content: "",
    packaging: 0,
    needPackaging: false,
    isFragile: false,
    isLiquid: false,
    cost: 20000000,
    serviceInPlace: 0,
  };

  if (isCod) shipmentTemplate.amountCOD = 0;

  const [rowsData, setRowsData] = useSessionStorage("rowsData", [
    shipmentTemplate,
  ]);

  const [errors, setErrors] = useState([]);
  const [submit, setSubmit] = useState(false);

  const [showModalRules, setShowModalRules] = useState(false);
  const [modalListService, setModalListService] = useState(false);
  const [modalBankAccount, setModalBankAccount] = useState(false);

  const [companies, setCompanies] = useState([]);
  const [confirmCodInfo, setConfirmCodInfo] = useState(false);

  const [detail, setDetail] = useSessionStorage("detailOrder", {
    totalCost: 0,
    totalNumber: 0,
    totalCollectiveWeight: 0,
    totalSpecialService: 0,
    totalGrossWeight: 0,
    totalPrint: 0,
    totalPackaging: 0,
    totalWeightPayable: 0,
  });

  const getData = async () => {
    const response = await getMethod("/componyservices/v1/all");

    if (response) {
      setCompanies(response);
    }
  };

  const handleChange = (index, evnt) => {
    const { name, value } = evnt.target;

    if (name === "weight") {
      if (value > 100) {
        return "ssad";
      }
    }

    if (name === "length" || name === "width" || name === "height") {
      if (value > 250) {
        return "";
      }
      if (value > 100) {
        Swal.fire({
          icon: "error",
          title: "اخطار",
          html: "<p style='font-size: 20px'>مرسوله با طول یا عرض یا ارتفاع بیشتر از 100 سانتی متر در یک بسته توسط اداره پست حمل نمیشود<br>مرسولات با با طول یا عرض یا ارتفاع بیشتر از 100 سانتی متر تا 250 سانتی متر توسط سرویس های ماهکس و چاپار و ... حمل میگردد </p>",
          confirmButtonText: '<i class="fa fa-thumbs-up"></i> فهمیدم',
          confirmButtonColor: "red",
          iconColor: "red",
        });
      }
    }

    setRowsData(cur => {
      cur[index][name] = name === "packaging" ? parseInt(value) : value;
      return [...cur];
    });

    if (errors.length !== 0) {
      setErrors(cur => {
        cur[index] = findFormErrors(index);
        return [...cur];
      });
    }
  };

  const findFormErrors = index => {
    const newErrors = {};

    const {
      packaging,
      weight,
      length,
      width,
      height,
      content,
      cost,
      serviceInPlace,
    } = rowsData[index];

    if (isCod) {
      const amountCOD = rowsData[index].amountCOD;

      if (
        amountCOD === "" ||
        amountCOD === undefined ||
        isNaN(amountCOD) ||
        amountCOD === null ||
        amountCOD < 0
      ) {
        newErrors.amountCOD = "حداقل مبلغ cod صفر است (پسکرایه)";
      }
    }

    if (!weight) {
      newErrors.weight = "وزن الزامی";
    } else if (weight < 0.05) {
      newErrors.weight = "حداقل وزن مرسوله 50 گرم";
    }

    if (!length || length < 1) {
      newErrors.length = "طول الزامی";
    }
    if (!width || width < 1) {
      newErrors.width = "عرض الزامی";
    }
    if (!height || height < 1) {
      newErrors.height = "ارتفاع الزامی";
    }
    if (!content) {
      newErrors.content = "مشخص کردن محتویات مرسوله الزامی است";
    }
    if (
      cost === "" ||
      cost === undefined ||
      isNaN(cost) ||
      cost === null ||
      cost < 0
    ) {
      newErrors.cost = "ارزش کالا الزامی";
    }
    if (!packaging || packaging === 0 || packaging === "0") {
      newErrors.packaging = "انتخاب نوع بسته بندی مرسوله الزامی";
    }

    if (serviceInPlace < 0) {
      newErrors.serviceInPlace = "حداقل مبلغ 0 ریال";
    }

    if (serviceInPlace > 15_000_000) {
      newErrors.serviceInPlace = "حداکثر مبلغ 1 میلیون 500 هزار تومان";
    }

    return newErrors;
  };

  const handleSubmit = () => {
    if (rowsData.length === 0) return;
    const totalErrrors = [];
    for (let idx = 0; idx < rowsData.length; idx++) {
      totalErrrors.push(findFormErrors(idx));
    }
    setErrors(() => totalErrrors);

    let noErrors = true;
    totalErrrors.forEach(item => {
      if (Object.keys(item).length > 0) {
        noErrors = false;
      }
    });

    if (noErrors === false) {
      swalFormErrorMessage(totalErrrors);
      return;
    }

    if (!SAddress?.id) {
      Swal.fire({
        icon: "error",
        text: "آدرس فرستنده مشخص نشده است",
        showConfirmButton: true,
        confirmButtonText: "متوجه شدم",
        confirmButtonColor: "gray",
      });
      return;
    }

    if (!RAddress?.id) {
      Swal.fire({
        icon: "error",
        text: "آدرس گیرنده مشخص نشده است",
        showConfirmButton: true,
        confirmButtonText: "متوجه شدم",
        confirmButtonColor: "gray",
      });
      return;
    }

    if (isCod === true) {
      if (!amountCODHandle()) {
        Swal.fire({
          icon: "warning",
          title: "هشدار",
          html: "<p style='font-size: 20px'>مبلغ سی او دی می تواند صفر یا برابر با ارزش کالا باشد</p>",
          showConfirmButton: false,
          cancelButtonText: '<i class="fa fa-thumbs-up"></i> فهمیدم',
          showCancelButton: true,
        });
        return;
      }

      const sumAmountCOD = rowsData.reduce(
        (sum, item) => item.amountCOD + sum,
        0
      );
      if (sumAmountCOD > 0) {
        setModalBankAccount(true);
        return;
      }
    }

    setShowModalRules(() => true);
  };

  const amountCODHandle = () => {
    const err = [];
    _.forEach(rowsData, function (value) {
      if (value.amountCOD === 0) {
        err.push(true);
      } else if (value.amountCOD !== value.cost) {
        err.push(false);
      }
    });

    if (_.includes(err, false)) {
      return false;
    } else {
      return true;
    }
  };

  const Codhandler = () => {
    Swal.fire({
      icon: "error",
      title: "اخطار",
      html: "<p style='font-size: 20px'>چنانچه مایلید مبلغ ارزش کالا از گیرنده دریافت شود مقادیر را در این فیلد وارد کنید</p>",
      confirmButtonText: '<i class="fa fa-thumbs-up"></i> فهمیدم',
      confirmButtonColor: "red",
      iconColor: "red",
    }).then(res => {
      if (res.isConfirmed) {
        setConfirmCodInfo(() => true);
      }
    });
  };

  const handleCheckBox = ({ target: { checked } }, index, name) => {
    setRowsData(cur => {
      cur[index][name] = checked;
      return [...cur];
    });
  };

  const addTableRows = () => {
    setRowsData(cur => [...cur, shipmentTemplate]);
  };

  const deleteTableRows = index => {
    setRowsData(cur => cur.filter((i, idx) => idx !== index));
  };

  const duplicateRow = idx => {
    setRowsData(cur => [...cur, { ...cur[idx] }]);
  };

  const getError = (name, idx) => {
    try {
      return {
        message: errors[idx][name],
        occurred: errors[idx][name] ? true : false,
      };
    } catch (error) {
      return { message: "", occurred: false };
    }
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (submit) {
      handleSubmit();
      setSubmit(false);
    }
  }, [submit]);

  useEffect(() => {
    setRowsData(cur =>
      cur.map(item => {
        item.massUnround = (item.width * item.height * item.length) / 6000;
        item.mass = Math.round(item.massUnround * 100) / 100;
        return item;
      })
    );
  }, [
    rowsData
      .map(item => [item.width, item.height, item.length].join(","))
      .join("|"),
  ]);

  useEffect(() => {
    if (isCod === false) {
      setRowsData(cur =>
        cur.map(item => {
          delete item.amountCOD;
          return item;
        })
      );
    }
  }, []);

  return (
    <div>
      <Form
        className="needs-validation"
        onSubmit={e => {
          e.preventDefault();
          setSubmit(true);
        }}
        onKeyDown={e => {
          if (e.key === "Enter" && e.target.nodeName === "INPUT") {
            const form = e.target.form;
            if (form?.elements === undefined) return;

            const index = Array.prototype.indexOf.call(form.elements, e.target);
            if (form.elements[index + 1]) {
              form.elements[index + 1].focus();
            }
            e.preventDefault();
          }
        }}
      >
        <Row>
          <p className="title-style">مشخصات مرسوله</p>
          <Table striped bordered hover responsive className="tbl-styl">
            <thead>
              <tr className="table-style">
                <th>شماره پارت</th>
                <th>وزن (کیلوگرم)</th>
                <th>طول * عرض * ارتفاع (cm)</th>
                <th>وزن حجمی</th>
                <th>محتویات و تعداد آن</th>
                <th>نوع بسته بندی</th>
                <th>نیازمند بسته بندی</th>
                <th>وضعیت</th>
                <th>ارزش کالا(ريال)</th>
                {isCod && <th>مبلغ COD</th>}
                <th>خدمات در محل</th>
                <th>
                  <button
                    type="button"
                    onClick={addTableRows}
                    className="p-0 m-0 btn btn-link"
                  >
                    <PlusSquareFill
                      size={22}
                      color="green"
                      title="افزودن سطر جدید"
                    />
                  </button>
                </th>
              </tr>
            </thead>
            <tbody>
              {rowsData.map((data, index) => {
                const {
                  partNumber,
                  weight,
                  length,
                  width,
                  height,
                  mass,
                  content,
                  packaging,
                  needPackaging,
                  isFragile,
                  isLiquid,
                  cost,
                  amountCOD,
                  serviceInPlace,
                } = data;

                return (
                  <tr className="table-body-style" key={index}>
                    <td style={{ minWidth: 100 }}>
                      <Form.Control
                        readOnly
                        type="text"
                        name="partNumber"
                        value={partNumber + index}
                        onChange={evnt => handleChange(index, evnt)}
                        isInvalid={getError("partNumber", index).occurred}
                      />
                      <Form.Control.Feedback type="invalid">
                        {getError("partNumber", index).message}
                      </Form.Control.Feedback>
                    </td>
                    <td style={{ minWidth: 110, maxWidth: 110 }}>
                      <Form.Control
                        type="number"
                        name="weight"
                        value={weight}
                        onChange={evnt => handleChange(index, evnt)}
                        placeholder=""
                        isInvalid={getError("weight", index).occurred}
                        onBlur={e => weightValidation(e)}
                      />
                      <Form.Control.Feedback type="invalid">
                        {getError("weight", index).message}
                      </Form.Control.Feedback>
                    </td>
                    <td style={{ minWidth: 240, maxWidth: 240 }}>
                      <div className="d-flex">
                        <Col xs={4} className="px-0">
                          <Form.Control
                            placeholder=""
                            type="number"
                            name="length"
                            value={length}
                            onChange={evnt => handleChange(index, evnt)}
                            isInvalid={getError("length", index).occurred}
                          />
                          <Form.Control.Feedback type="invalid">
                            {getError("length", index).message}
                          </Form.Control.Feedback>
                        </Col>
                        <Col xs={4} className="px-1">
                          <Form.Control
                            placeholder=""
                            type="number"
                            name="width"
                            value={width}
                            onChange={evnt => handleChange(index, evnt)}
                            isInvalid={getError("width", index).occurred}
                          />
                          <Form.Control.Feedback type="invalid">
                            {getError("width", index).message}
                          </Form.Control.Feedback>
                        </Col>
                        <Col xs={4} className="px-0">
                          <Form.Control
                            placeholder=""
                            type="number"
                            name="height"
                            value={height}
                            onChange={evnt => handleChange(index, evnt)}
                            isInvalid={getError("height", index).occurred}
                          />
                          <Form.Control.Feedback type="invalid">
                            {getError("height", index).message}
                          </Form.Control.Feedback>
                        </Col>
                      </div>
                    </td>
                    <td style={{ minWidth: 100, maxWidth: 100 }}>
                      <Form.Control
                        type="number"
                        name="mass"
                        value={mass}
                        readOnly={true}
                        placeholder=""
                      />
                    </td>
                    <td style={{ minWidth: 200 }}>
                      <Form.Control
                        type="text"
                        name="content"
                        value={content}
                        onChange={evnt => handleChange(index, evnt)}
                        isInvalid={getError("content", index).occurred}
                        placeholder="مثلا:4 عدد گوشی موبایل"
                      />
                      <Form.Control.Feedback type="invalid">
                        {getError("content", index).message}
                      </Form.Control.Feedback>
                    </td>
                    <td style={{ minWidth: 180 }}>
                      <PackageSelect
                        name="packaging"
                        value={packaging}
                        style={{ height: "35px", marginLeft: 20 }}
                        onChange={value =>
                          handleChange(index, {
                            target: { value, name: "packaging" },
                          })
                        }
                        isInvalid={getError("packaging", index).occurred}
                      />
                      <Form.Control.Feedback type="invalid">
                        {getError("packaging", index).message}
                      </Form.Control.Feedback>
                    </td>
                    <td style={{ minWidth: 130 }}>
                      <div className="d-flex justify-content-center align-items-center pt-1">
                        <input
                          type="checkbox"
                          name="needPackaging"
                          style={{ width: 50, height: 30 }}
                          onChange={e =>
                            handleCheckBox(e, index, "needPackaging")
                          }
                          value={needPackaging}
                          checked={needPackaging}
                        />
                      </div>
                    </td>
                    <td style={{ minWidth: 220 }}>
                      <div
                        className={
                          "d-flex justify-content-between " + style.status
                        }
                      >
                        <div className="d-flex justify-content-between align-items-center">
                          <span>مایعات</span>
                          <input
                            type="checkbox"
                            value={isLiquid}
                            checked={isLiquid}
                            onChange={e => handleCheckBox(e, index, "isLiquid")}
                          />
                        </div>
                        <div className="d-flex justify-content-between align-items-center">
                          <span>شکستنی</span>
                          <input
                            type="checkbox"
                            value={isFragile}
                            checked={isFragile}
                            onChange={e =>
                              handleCheckBox(e, index, "isFragile")
                            }
                          />
                        </div>
                      </div>
                    </td>
                    <td style={{ minWidth: 150 }}>
                      <NumericFormat
                        suffix=" ریال"
                        name="cost"
                        thousandSeparator=","
                        value={cost}
                        className="form-control"
                        onValueChange={({ value }) => {
                          handleChange(index, {
                            target: { value: parseInt(value), name: "cost" },
                          });
                        }}
                      />
                      {getError("cost", index).occurred && (
                        <p className="text-danger fs-6">
                          {getError("cost", index).message}
                        </p>
                      )}
                    </td>

                    {isCod && (
                      <td style={{ minWidth: 150 }}>
                        <NumericFormat
                          suffix=" ریال"
                          name="amountCOD"
                          thousandSeparator=","
                          value={amountCOD}
                          className="form-control"
                          onClick={
                            confirmCodInfo === false ? Codhandler : undefined
                          }
                          onValueChange={({ value }) => {
                            handleChange(index, {
                              target: {
                                value: parseInt(value),
                                name: "amountCOD",
                              },
                            });
                          }}
                        />
                        {getError("amountCOD", index).occurred && (
                          <p className="text-danger fs-6">
                            {getError("amountCOD", index).message}
                          </p>
                        )}
                      </td>
                    )}

                    <td style={{ minWidth: 150 }}>
                      <NumericFormat
                        suffix=" ریال"
                        name="serviceInPlace"
                        thousandSeparator=","
                        value={serviceInPlace}
                        className="form-control"
                        onValueChange={({ value }) => {
                          handleChange(index, {
                            target: {
                              value: parseInt(!value ? 0 : value),
                              name: "serviceInPlace",
                            },
                          });
                        }}
                      />

                      {getError("serviceInPlace", index).occurred && (
                        <p className="text-danger fs-6">
                          {getError("serviceInPlace", index).message}
                        </p>
                      )}
                    </td>

                    <td style={{ width: 80 }}>
                      <Row
                        className={
                          "d-flex align-items-center justify-content-center " +
                          style.minWidth80
                        }
                      >
                        <button
                          type="button"
                          onClick={() => deleteTableRows(index)}
                          className="d-inline-block p-1 mx-0 buton-form btn btn-link"
                        >
                          <TrashFill
                            color="red"
                            size={20}
                            className=""
                            title="حذف سطر"
                          />
                        </button>
                        <button
                          type="button"
                          onClick={() => duplicateRow(index)}
                          className="d-inline-block p-1 mx-0 buton-form btn btn-link"
                        >
                          <Files color="blue" size={20} title="کپی سطر" />
                        </button>
                      </Row>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>

          <FormShipmentInfo
            detail={detail}
            rowsData={rowsData}
            setDetail={setDetail}
          />

          <hr />
        </Row>
        <div className="text-center">
          <Button type="submit" className="btn-success-style">
            تائید
          </Button>
        </div>
      </Form>

      {showModalRules === true && (
        <ModalRules
          close={() => setShowModalRules(() => false)}
          sumbit={() => setModalListService(() => true)}
        />
      )}

      {modalListService === true && (
        <PostServiceList
          rowsData={rowsData}
          companies={companies}
          close={() => setModalListService(false)}
          isCod={isCod}
          detail={detail}
        />
      )}

      {modalBankAccount && (
        <ChooseBankAccountForOrder
          senderAddressId={SAddress?.id}
          onClose={() => setModalBankAccount(false)}
          onChoose={value => {
            setModalBankAccount(false);
            setDetail(cur => ({ ...cur, bankAccountId: value.id }));
            setShowModalRules(true);
          }}
        />
      )}
    </div>
  );
}

export default FormShipment;
